import React from 'react'

export default function TableCellResultCheck(props) {

  const {win, lose, draw, answer, onSelectChange} = props

  const getCheckImage = (index, type) => {
    let result = '/assets/image/chk3.png'
    if (index === type) {
      if (answer == index) {
        result = '/assets/image/chk3_b_on.png'
      } else if (answer == -1) {
        result = '/assets/image/chk3_or.png'
      } else {
        result = '/assets/image/chk3_r_on.png'
      }
    }
    return result
  }

  return (
    <div className={'d-center ' + props.className}>
      <img className='cursor-point' src={getCheckImage(0, win)} alt='' width={18} height={18} onClick={() => {onSelectChange(0)}}/>
      <img className='mh-12 sm-mh-7' style={{backgroundColor:'#00000050'}} width={1} height={30} />
      <img className='cursor-point' src={getCheckImage(1, draw)} alt='' width={18} height={18} onClick={() => {onSelectChange(1)}}/>
      <img className='mh-12 sm-mh-7' style={{backgroundColor:'#00000050'}} width={1} height={30} />
      <img className='cursor-point' src={getCheckImage(2, lose)} alt='' width={18} height={18} onClick={() => {onSelectChange(2)}}/>
    </div>
  )
}

